export default "__VITE_ASSET__CYFgYSsy__"